import React, { useState, useRef } from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Copy } from "lucide-react";
const Home = () => {
  const handleDownload = () => {
    const cssFilePath = "/v2.0.1.zip";
    const link = document.createElement('a');
    link.href = cssFilePath;
    link.download = "v2.0.1.zip";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const initialCdnUrl = "https://carve.enminvithaigal.in/v2.0.1/css/carve.css";
  const initialCdnUrljs = "https://carve.enminvithaigal.in/v2.0.1/js/carve.js";
  const [cdnUrl] = useState(initialCdnUrl);
  const [cdnUrlJs] = useState(initialCdnUrljs);
  const cssInputRef = useRef(null);
  const jsInputRef = useRef(null);

  const handleCopyClick = (ref) => {
    if (ref.current) {
      ref.current.select();
      document.execCommand("copy");
    }
  };

  return (
    <div className="home-section">
      <motion.div
        initial={{ x: 10, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -10, opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <div className="Home">
          <div className="carve-h-app-container">
            <section className="carve-space-bottom-hefty carve-h-hero">
              <h1>Carve CSS Universe</h1> <br />
              <br />

              <h5>
                A lightweight and customizable library for building modern web
                applications.
              </h5>{" "}
              <br />
              <br />
              <section className="carve-h-cta">
                <Link to="/accordion" aria-label="Go to Components">
                  <button className="carve-button-main spa">
                    Go to Components
                  </button>
                </Link>
              </section>
              <br />
              <br />
              <button className="carve-button-main" onClick={handleDownload}>
                Download (LTS)
              </button>{" "}
              <br />
              <br />
              (or)
            </section>
            <div className="input-field mandate home_input">
              <input
                type="text"
                required=""
                id="cssValue"
                value={cdnUrl}
                readOnly
                ref={cssInputRef}
              />
              <label
                htmlFor="cssValue"
                style={{
                  top: "-0.7rem",
                  fontSize: "90%",
                  padding: "0rem 1.5rem",
                }}
              >
                CDN for CSS (LTS)
              </label>
              <button
                onClick={() => handleCopyClick(cssInputRef)}
                aria-label="copy-button">
                <Copy />
              </button>
            </div>
            <div className="input-field mandate home_input">
              <input
                type="text"
                required=""
                id="jsValue"
                value={cdnUrlJs}
                readOnly
                ref={jsInputRef}
              />
              <label
                htmlFor="jsValue"
                style={{
                  top: "-0.7rem",
                  fontSize: "90%",
                  padding: "0rem 1.5rem",
                }}
              >
                CDN for JS
              </label>
              <button
                onClick={() => handleCopyClick(jsInputRef)}
                aria-label="copy-button"
              >
                <Copy />
              </button>
            </div>
            <section className="carve-space-bottom-hefty carve-h-features">
              <div className="carve-card uti-card">
                <div className="carve-card-head">Responsive Design</div>
                <div className="carve-card-body">
                  Build responsive and mobile-friendly websites with ease.
                </div>
              </div>
              <div className="carve-card uti-card">
                <div className="carve-card-head">Extensible Components</div>
                <div className="carve-card-body">
                  Use a variety of components to create rich user interfaces.
                </div>
              </div>
              <div className="carve-card uti-card">
                <div className="carve-card-head">Easy to Customize</div>
                <div className="carve-card-body">
                  Customize the look and feel to match your brand's identity.
                </div>
              </div>
            </section>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

Home.propTypes = {};

export default Home;
